import React from "react";
import { ReviewTable } from "./Table/ReviewTable";

function ReviewsList() {
  return (
    <div>
      <ReviewTable />
    </div>
  );
}

export default ReviewsList;
